import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "../../components/Common/TableContainer";
import orderColumns from "components/Columns/OrderColumns";
import { DELETE_ORDER, ORDER_LIST } from "helpers/url_helper";
import { del, get } from "helpers/api_helper";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import EditOrderModal from "./EditOrderModal";
import { useCallback } from "react";

const Order = () => {
  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Orders", link: "#" },
  ];

  const [orders, setOrders] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [sortBy, setSortBy] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const navigate = useNavigate();
  const didFetchRef = useRef(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const role = Number(authUser?.user?.role);
      setIsAdmin(role === 1);
      setPageSize(role ? 10 : 50);
    } catch {
      setIsAdmin(false);
      setPageSize(50);
    }
  }, []);

  const getOrderList = async (page, size, sort = [], search = "") => {
    const sortKey = sort[0]?.id;
    const sortby = sort[0]?.desc ? "asc" : "desc";

    return await get(ORDER_LIST, {
      params: { page, size, sortKey, sortby, search },
    });
  };

const fetchOrders = async (page = 1, size = 10, sortBy = [], searchText = "") => {
    try {
      const response = await getOrderList(page, size, sortBy, searchText); // Assuming your API takes page & size
      const { items, totalPages } = response.data;

      setOrders(items);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    }
};

  const prevParams = useRef({});

useEffect(() => {
  fetchOrders(pageIndex, pageSize, sortBy, searchText);
}, [pageIndex, pageSize, sortBy, searchText]);

  // useEffect(() => {
  //   fetchOrders(pageIndex, pageSize, sortBy, searchText);
  // }, [pageIndex, pageSize, sortBy, searchText]);

  const handleSearchChange = (text) => {
    setPageIndex(1);
    setSearchText(text);
  };

  const handleEdit = useCallback((item) => {
    setSelectedOrder(item);
    setEditModalOpen(true);
  }, []);

  const handleDelete = useCallback((item) => {
    setSelectedOrder(item);
    setModalOpen(true);
  }, []);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const confirmDelete = async () => {
    try {
      if (selectedOrder) {
        await del(DELETE_ORDER(selectedOrder.ul_id));
        toastr.success("Order deleted successfully!");
        fetchOrders(pageIndex, pageSize, sortBy, searchText);
      }
    } catch (error) {
      console.error(
        "Failed to delete order:",
        error?.response?.data || error?.message
      );
      toastr.error("Something went wrong while deleting.");
    }
    setModalOpen(false);
  };

  const columns = useMemo(
    () => orderColumns(handleEdit, handleDelete, isAdmin),
    [handleEdit, handleDelete, isAdmin]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Order List" breadcrumbItems={breadcrumbItems} />
        </Container>

        <Card>
          <CardBody>
            {loading ? (
              <div className="text-center">Loading...</div>
            ) : orders.length > 0 ? (
              <TableContainer
                columns={columns || []}
                data={orders || []}
                isPagination={true}
                isGlobalFilter={true}
                customPageSize={pageSize}
                isAddOptions={true}
                addOptionTitle={"Add New Order"}
                iscustomPageSize={false}
                isBordered={false}
                controlledPagination={{
                  pageIndex,
                  setPageIndex,
                  pageSize,
                  setPageSize,
                  totalPages,
                }}
                onSortChange={setSortBy}
                searchText={searchText}
                onSearchChange={handleSearchChange}
                handleAddClick={() => navigate("/add-order")}
              />
            ) : (
              <div className="text-center py-5">
                <h5>No Record Found</h5>
                <Link to="/add-order" className="btn btn-primary mt-3">
                  Add New Order
                </Link>
              </div>
            )}
          </CardBody>
        </Card>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this Order permanently?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          <Button color="danger" onClick={confirmDelete}>
            Yes, Delete
          </Button>
        </ModalFooter>
      </Modal>

      {/* Edit Order Modal */}
      <EditOrderModal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(false)}
        orderData={selectedOrder}
        onUpdated={() => fetchOrders(pageIndex, pageSize, sortBy, searchText)}
      />
    </React.Fragment>
  );
};

export default Order;
